import _ from 'lodash';
import {ResizeObserver as ResizeObserverPolyfill} from '@juggle/resize-observer';

let resizeObserver = registerNewObserver();
let observations = [];
// eslint-disable-next-line no-undef
const observersCounterKey = Symbol('resizeObserversCounter');

function registerNewObserver() {
	const resizeObserverClass = window.ResizeObserver || ResizeObserverPolyfill;
	const allEntries = [];
	const els = [];
	const debouncedResize = _.debounce(() => {
		onResize(allEntries);
		const ln = allEntries.length;
		allEntries.splice(0, ln);
		els.splice(0, ln);
	}, 150);
	return new resizeObserverClass(entries => {
		let i = entries.length;
		while (i--) {
			const entry = entries[i];
			const idx = els.indexOf(entry.target);
			if (idx >= 0) {
				allEntries[idx] = entry;
			} else {
				allEntries.push(entry);
				els.push(entry.target);
			}
		}
		debouncedResize();
	});

}

function onResize(entries) {
	let observationsToDrop = null;
	let i = observations.length;
	while (i--) {
		const observation = observations[i];
		if (observation.observer && observation.observer._isDestroyed) {
			observationsToDrop = observationsToDrop || [];
			observationsToDrop.push(observation);
			continue;
		}
		let j = entries.length;
		const el = observation.el;
		while (j--) {
			if (entries[j].target === el) {
				observation.callback(entries[j]);
				break;
			}
		}
	}
	if (observationsToDrop) {
		observationsToDrop.forEach(unobserve);
	}
}

function unobserve(observation) {
	const idx = observations.indexOf(observation);
	if (idx < 0) return;
	observations.splice(idx, 1);
	const el = observation.el;
	el[observersCounterKey]--;
	if (el[observersCounterKey] <= 0) {
		resizeObserver.unobserve(el);
	}
}

function observe(observer, el, callback) {
	if (!callback || !el) return;
	const observation = {observer, el, callback};
	observations.push(observation);
	resizeObserver.observe(el);
	if (!el[observersCounterKey]) {
		el[observersCounterKey] = 0;
	}
	el[observersCounterKey]++;
	return function () {
		unobserve(observation);
	};
}

export default {
	observe
};